import { useState, useCallback } from 'react';
import { accountService } from '@/features/card/services/accountService/accountService';
import { useSpinner } from '@chikara/ui';
import { t } from '@/i18n';

export const useRejectAccount = () => {
    const { show, hide, isSpinnerLoading } = useSpinner();
    const [error, setError] = useState<string | null>(null);

    const rejectAccount = useCallback(async (payload: any): Promise<boolean> => {
        show();
        setError(null);
        try {
            await accountService.rejectAccount(payload);
            return true;
        } catch (err) {
            setError(t('dashboard.card.detail.modals.rejectCard.errors.generic'));
            return false;
        } finally {
            hide();
        }
    }, [show, hide]);

    return {
        rejectAccount,
        isLoading: isSpinnerLoading,
        error
    };
};
